module.exports = __webpack_public_path__ + "img/straight-rail-horizontal-backplates.df9bd725.png";